const keyList = {
  countryInfo: "countryInfo", //注册时选择的国家信息
  mfaId: "mfaId", //mfaId
  token: "token", //token
  "2fa_new": "2fa_new", //2fa验证项以及优先级
  "2fa": "2fa", //2fa验证项以及优先级
  faResultId: "faResultId", // 2fa校验结果凭证
  faId: "faId", // 2fa校验结果凭证
  puzzleValidateString: "puzzleValidateString", // 人机验证信息
  oauth2: "oauth2", // 授权登录信息
  googleBindThird: "googleBindThird", // Google/Apple 登录需关联账号时的 payload
  googleSetPassword: "googleSetPassword", // Google/Apple 新用户需设置密码标记
  googleSetPasswordThirdType: "googleSetPasswordThirdType", // 设置密码页展示的第三方名称
};

export default {
  keyList,
  get(key) {
    if (typeof window === "undefined") return "";
    const itemKey = keyList[key];
    if (!itemKey) {
      console.log(
        "%c$storage.get 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );
      return "";
    }
    try {
      const itemValue = sessionStorage.getItem(itemKey);
      let result;
      try {
        result = itemValue == null ? null : JSON.parse(itemValue);
      } catch (e) {
        result = itemValue;
      }
      return result || "";
    } catch (e) {
      // 无痕/隐私模式、禁用存储或 iframe 等场景下 getItem 可能抛错，避免导致整页白屏
      return "";
    }
  },
  set(key, value) {
    if (typeof window === "undefined") return;
    const itemKey = keyList[key];
    if (!itemKey)
      return console.log(
        "%c$storage.set 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    try {
      sessionStorage.setItem(itemKey, JSON.stringify(value));
    } catch (e) {
      sessionStorage.setItem(itemKey, value);
    }
  }, //对象会被压成字符串
  remove(key) {
    if (typeof window === "undefined") return;
    const itemKey = keyList[key];
    if (!itemKey)
      return console.log(
        "%c$storage.remove 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    sessionStorage.removeItem(itemKey);
  },
  clear() {
    if (typeof window === "undefined") return;
    sessionStorage.clear();
    return true;
  },
};
